var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-collapsible",
    {
      ref: "colpsbl",
      attrs: { icon: "fa-bell", label: "Заявка " + this.lblDate }
    },
    [
      _c("div", [
        _c("p", [
          _c("small", { staticClass: "tview-label" }, [_vm._v("Пин-код")]),
          _vm._v(" "),
          _c("span", { staticClass: "text-bolder" }, [
            _vm._v(_vm._s(_vm.request.pin))
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _c("small", { staticClass: "view-label" }, [_vm._v("Клиент")]),
          _vm._v(" "),
          _c("span", { staticClass: "text-bolder" }, [
            _vm._v(_vm._s(_vm.request.hospital))
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _c("small", { staticClass: "view-label" }, [_vm._v("Место")]),
          _vm._v(" "),
          _c("span", { staticClass: "text-bolder" }, [
            _vm._v(_vm._s(_vm.request.place))
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _c("small", { staticClass: "view-label" }, [_vm._v("Прибор")]),
          _vm._v(" "),
          _c("span", { staticClass: "text-bolder" }, [
            _vm._v(_vm._s(_vm.request.analyzer))
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _c("small", { staticClass: "view-label" }, [_vm._v("Проблема")]),
          _vm._v(" "),
          _c("span", { staticClass: "text-bolder" }, [
            _vm._v(_vm._s(_vm.request.defect))
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _c("small", { staticClass: "view-label" }, [_vm._v("Контакт")]),
          _vm._v(" "),
          _c("span", { staticClass: "text-bolder" }, [
            _vm._v(_vm._s(_vm.request.person))
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _c("small", { staticClass: "view-label" }, [_vm._v("Телефон")]),
          _vm._v(" "),
          _c("span", { staticClass: "text-bolder" }, [
            _vm._v(_vm._s(_vm.request.telephone))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5477167e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5477167e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/request-card.vue
// module id = null
// module chunks = 